import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useSubsidiariesApi } from "../../http/subsidiaries/api";
import ModalDialog from "../ui/ModalDialog";

type DeleteSubsidiaryDialogProps = {
  subsidiaryId: string;
  onClose: () => void;
};

const DeleteSubsidiaryDialog: FC<DeleteSubsidiaryDialogProps> = ({ onClose, subsidiaryId }) => {
  const i18n = useI18n();
  const subsidiariesApi = useSubsidiariesApi();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.subsidiaries.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,

          onClick: () => {
            setIsSubmitting(true);
            subsidiariesApi
              .deleteAdminSubsidiary(subsidiaryId)
              .then(onClose)
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.subsidiaries.questions.delete}
    </ModalDialog>
  );
};

export default DeleteSubsidiaryDialog;
